// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const SectionContainer = styled.div`
  width: 100%;
  padding: 1rem 1.5rem 0;
  border-bottom: 1px solid var(--mb-color-border-neutral);
`;

export const ChartSettingsListContainer = styled.div`
  position: relative;
  padding: 1.5rem 0 0;
  flex: 1;
  overflow: auto;
`;
